import React,{useState} from 'react';
import PLC from './PLC';

function VerPLC() {
  /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
  var [code, setCode] = useState(null);
  if(code == null) {
      let valor = parseInt(sessionStorage.getItem('key')) + 1;
      setCode(valor);
      sessionStorage.setItem("key", valor)
  }
  return (
    <div>
      <PLC code={code}/>
    </div>
  )
}

export default VerPLC